import { useState } from "react";
import type { OrderType } from "@mnp/shared";
import { shortId, formatDateTime } from "../../lib/orders";
import { useClientOrders } from "../../lib/useClients";

// Фильтр «Ozon / WB» удалён 2026-06-12 — модуль заархивирован в ветке
// Сервер не отдаёт строки архивных направлений (PR5 в main); нейтральный
// рендер неизвестного типа оставлен защитой в глубину (архив archive/ozonwb-flow).
const TYPE_FILTERS: { id: OrderType; label: string }[] = [
  { id: "all", label: "Все" },
  { id: "flex", label: "Flex" },
  { id: "shop", label: "Упаковка" },
];

const TYPE_TONE: Record<string, string> = {
  flex: "teal",
  shop: "purple",
};

/**
 * Client orders tab. The type filter re-queries the server (the unified
 * /admin/clients/:id/orders aggregator already accepts ?type=), so the list is
 * always server-paginated rather than filtered client-side.
 */
export function ClientOrdersTab({
  clientId,
  onOpenOrder,
}: {
  clientId: string;
  onOpenOrder?: (row: { id: string; type: string }) => void;
}) {
  const [filter, setFilter] = useState<OrderType>("all");
  const { data, isLoading } = useClientOrders(clientId, filter);
  const rows = data?.rows ?? [];

  return (
    <>
      <div className="cd-filter">
        {TYPE_FILTERS.map((t) => (
          <button
            key={t.id}
            data-active={filter === t.id}
            onClick={() => setFilter(t.id)}
          >
            {t.label}
            {t.id === "all" && data ? <span>{data.total}</span> : null}
          </button>
        ))}
      </div>

      {isLoading ? (
        <div className="cd-empty">
          <p>Загрузка…</p>
        </div>
      ) : rows.length === 0 ? (
        <div className="cd-empty">
          <span style={{ fontSize: 32 }}>📭</span>
          <p>Нет заказов в этой категории</p>
        </div>
      ) : (
        <div className="cd-order-list">
          {rows.map((o) => (
            <button
              key={`${o.type}-${o.id}`}
              className="cd-order-row"
              onClick={() => onOpenOrder?.({ id: o.id, type: o.type })}
            >
              <div className="cd-order-top">
                <span className="mono cd-order-id">{shortId(o.id)}</span>
                <span className={"micro-tag tone-" + (TYPE_TONE[o.type] ?? "gray")}>
                  {o.type}
                </span>
                <span className="badge-a gray">{o.statusLabel}</span>
                <span className="cd-order-sum">
                  {o.amount ? `${o.amount} ${o.currency ?? ""}`.trim() : "—"}
                </span>
              </div>
              <p className="cd-order-meta">
                {o.clientName} · {formatDateTime(o.createdAt)}
              </p>
            </button>
          ))}
        </div>
      )}
    </>
  );
}
